export type ApartmentPickerOption = {
  id: string;
  code: string;
  name?: string | null;
};

export function toApartmentPickerOptions(data: unknown): ApartmentPickerOption[] {
  if (!data) {
    return [];
  }
  const list = Array.isArray(data) ? data : [data];
  return list
    .filter((item): item is Record<string, unknown> => item != null && typeof item === 'object')
    .map((apt) => ({
      id: String(apt.id),
      code: String(apt.code),
      name: apt.name != null && apt.name !== '' ? String(apt.name) : null,
    }));
}
